module.exports = __webpack_public_path__ + "static/media/undraw_bus_stop_re_h8ej.44947e30.svg";